import { render, staticRenderFns } from "./ExpireList.vue?vue&type=template&id=58dd905e&scoped=true&"
import script from "./ExpireList.vue?vue&type=script&lang=js&"
export * from "./ExpireList.vue?vue&type=script&lang=js&"
import style0 from "./ExpireList.vue?vue&type=style&index=0&id=58dd905e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dd905e",
  null
  
)

export default component.exports